export enum ZINDEX {
  AdminSidebar = 2,
  AutocompleteResult = 5,
  ButtonFocusVisible = 10,
  Modal = 30,
  ChartTooltip = 999,
  Tooltip = 1000,
}
